export const codeToSlugNameMap = {
	BAR: {
		href: 'bar-services',
		name: 'Bar Services',
		shortName: 'Bar Services',
		terms: {
			title: 'Beverage services',
			singular: 'Beverage Service',
			plural: 'Beverage Services',
			iconName: 'glass',
		},
	},
	BEA: {
		href: 'beauty-services',
		name: 'Beauty',
		shortName: 'Beauty',
		terms: {
			title: 'Beauty',
			singular: 'Beauty Service',
			plural: 'Beauty Services',
			iconName: 'lipstick',
		},
	},
	BWP: {
		href: 'bridal-salons',
		name: 'Bridal Salons',
		shortName: 'Bridal Salons',
		terms: {
			title: 'Bridal salons',
			singular: 'Bridal Salon',
			plural: 'Bridal Salons',
			iconName: 'dress',
		},
	},
	CAT: {
		href: 'catering',
		name: 'Caterers',
		shortName: 'Caterers',
		terms: {
			title: 'Caterers',
			singular: 'Caterer',
			plural: 'Caterers',
			iconName: 'cutlery',
		},
	},
	DNC: {
		href: 'wedding-dance-lessons',
		name: 'Dance Lessons',
		shortName: 'Dance Lessons',
		terms: {
			title: 'Dance lessons',
			singular: 'Dance Studio',
			plural: 'Dance Studios',
			iconName: 'footprints',
		},
	},
	DEC: {
		href: 'wedding-decor-shops',
		name: 'Decor',
		shortName: 'Decor',
		terms: {
			title: 'Decor',
			singular: 'Decor Designer',
			plural: 'Decor Designers',
			iconName: 'bunting',
		},
	},
	DJS: {
		href: 'wedding-djs',
		name: 'DJs',
		shortName: 'DJs',
		terms: {
			title: 'DJs',
			singular: 'DJ',
			plural: 'DJs',
			iconName: 'dj',
		},
	},
	ENS: {
		href: 'wedding-soloists-ensembles',
		name: 'Ensembles + Soloists',
		shortName: 'Ensembles + Soloists',
		terms: {
			title: 'Soloists & ensembles',
			singular: 'Musician',
			plural: 'Musicians',
			iconName: 'quaver',
		},
	},
	FAV: {
		href: 'favors',
		name: 'Favors + Gifts',
		shortName: 'Favors + Gifts',
		terms: {
			title: 'Favors & gifts',
			singular: 'Favors & Gift Seller',
			plural: 'Favors & Gift Sellers',
			iconName: 'bag-heart',
		},
	},
	FLO: {
		href: 'florists',
		name: 'Florists',
		shortName: 'Florists',
		terms: {
			title: 'Florists',
			singular: 'Florist',
			plural: 'Florists',
			iconName: 'daisy',
		},
	},
	HRB: {
		href: 'wedding-room-blocks',
		name: 'Hotel Room Blocks',
		shortName: 'Hotel Room Blocks',
		terms: {
			title: 'Hotel room blocks',
			singular: 'Hotel Room Block',
			plural: 'Hotel Room Blocks',
			iconName: 'bell',
		},
	},
	INV: {
		href: 'invitations',
		name: 'Invitations + Paper Goods',
		shortName: 'Invitations + Paper Goods',
		terms: {
			title: 'Invitations & paper goods',
			singular: 'Designer',
			plural: 'Designers',
			iconName: 'mail-open',
		},
	},
	JWL: {
		href: 'jewelers',
		name: 'Jewelers',
		shortName: 'Jewelers',
		terms: {
			title: 'Jewelers',
			singular: 'Jeweler',
			plural: 'Jewelers',
			iconName: 'diamond',
		},
	},
	OPC: {
		href: 'wedding-officiants',
		name: 'Officiants + Premarital Counseling',
		shortName: 'Officiants + Premarital Counseling',
		terms: {
			title: 'Officiants & premarital counselors',
			singular: 'Officiant',
			plural: 'Officiants',
			iconName: 'book-opened',
		},
	},
	PHB: {
		href: 'wedding-photo-booth-rentals',
		name: 'Photo Booths',
		shortName: 'Photo Booths',
		terms: {
			title: 'Photo booths',
			singular: 'Photo Booth Rental',
			plural: 'Photo Booth Rentals',
			iconName: 'photo-strips',
		},
	},
	REC: {
		href: 'wedding-reception-venues',
		name: 'Reception Venues',
		shortName: 'Reception Venues',
		terms: {
			title: 'Venues',
			singular: 'Venue',
			plural: 'Venues',
			iconName: 'champagne-glass',
		},
	},
	SPV: {
		href: 'rehearsal-dinners-bridal-showers',
		name: 'Rehearsal Dinners, Bridal Showers + Parties',
		shortName: 'Rehearsal Dinners, Bridal Showers + Parties',
		terms: {
			title: 'Rehearsal dinners, showers & parties',
			singular: 'Private Event Space',
			plural: 'Private Event Spaces',
			iconName: 'balloons',
		},
	},
	RNT: {
		href: 'wedding-rentals',
		name: 'Rentals',
		shortName: 'Rentals',
		terms: {
			title: 'Wedding rentals',
			singular: 'Wedding Rental',
			plural: 'Wedding Rentals',
			iconName: 'sofa',
		},
	},
	TRA: {
		href: 'transportation-services',
		name: 'Transportation',
		shortName: 'Transportation',
		terms: {
			title: 'Transportation',
			singular: 'Transportation Service',
			plural: 'Transportation Services',
			iconName: 'bus',
		},
	},
	TRV: {
		href: 'wedding-travel-agents',
		name: 'Travel Specialists',
		shortName: 'Travel Specialists',
		terms: {
			title: 'Travel agents',
			singular: 'Travel Agent',
			plural: 'Travel Agents',
			iconName: 'plane',
		},
	},
	VID: {
		href: 'wedding-videographers',
		name: 'Videographers',
		shortName: 'Videographers',
		terms: {
			title: 'Videographers',
			singular: 'Videographer',
			plural: 'Videographers',
			iconName: 'camera-video',
		},
	},
	BDS: {
		href: 'live-wedding-bands',
		name: 'Wedding Bands',
		shortName: 'Bands',
		terms: {
			title: 'Live bands',
			singular: 'Live Band',
			plural: 'Live Bands',
			iconName: 'guitar',
		},
	},
	WCK: {
		href: 'wedding-cake-bakeries',
		name: 'Wedding Cakes',
		shortName: 'Cakes',
		terms: {
			title: 'Cakes',
			singular: 'Bakery',
			plural: 'Bakeries',
			iconName: 'cake',
		},
	},
	WPH: {
		href: 'wedding-photographers',
		name: 'Wedding Photographers',
		shortName: 'Photographers',
		terms: {
			title: 'Photographers',
			singular: 'Photographer',
			plural: 'Photographers',
			iconName: 'camera-pro',
		},
	},
	PLN: {
		href: 'wedding-planners',
		name: 'Wedding Planners',
		shortName: 'Wedding Planners',
		terms: {
			title: 'Planners',
			singular: 'Planner',
			plural: 'Planners',
			iconName: 'clipboard',
		},
	},
};

const sortedCategories = (sortKey) =>
	Object.entries(codeToSlugNameMap)
		.sort((a, b) => a[1][sortKey].localeCompare(b[1][sortKey]))
		.map((ary) => ary[0]);

/** @knipignore */
export const categoriesSortedByShortName = sortedCategories('shortName');

export const categorySlugsRegex =
	'bridal-accessory-shops|dress-preservation-cleaning|bar-services|beauty-services|bed-and-breakfasts|boudoir-photographers|bridal-salons|calligraphers|catering|ceremony-accessories|wedding-ceremony-venues|wedding-dance-lessons|wedding-decor-shops|desserts|wedding-djs|wedding-soloists-ensembles|favors|fitness|florists|wedding-room-blocks|invitations|jewelers|wedding-lighting|wedding-menswear|newlywed-services|wedding-officiants|wedding-photo-booth-rentals|wedding-reception-venues|registry-services|rehearsal-dinners-bridal-showers|wedding-rentals|service-staff|technologies|transportation-services|wedding-travel-agents|vacation-homes-villas|variety-acts|wedding-videographers|live-wedding-bands|wedding-cake-bakeries|wedding-designers|wedding-jewelry-stores|wedding-photographers|wedding-planners';

// Google Maps are not used in Wedding Receptions, Bridal Salons and Hotel Room Blocks
export const categoryHasMap = (code) =>
	!['REC', 'BWD', 'HRB'].some((x) => x === code);

export default codeToSlugNameMap;
